import { render, staticRenderFns } from "./PageButtonFormStepped.vue?vue&type=template&id=23c18815&scoped=true"
import script from "./PageButtonFormStepped.vue?vue&type=script&lang=js"
export * from "./PageButtonFormStepped.vue?vue&type=script&lang=js"
import style0 from "./PageButtonFormStepped.vue?vue&type=style&index=0&id=23c18815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c18815",
  null
  
)

export default component.exports